module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/isarray/index.js
// module id = 708
// module chunks = 0